import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=3427d80c&scoped=true"
import script from "./add-or-update.vue?vue&type=script&lang=js"
export * from "./add-or-update.vue?vue&type=script&lang=js"
import style0 from "./add-or-update.vue?vue&type=style&index=0&id=3427d80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules_admin/6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3427d80c",
  null
  
)

export default component.exports